import { ActionList, Divider } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { AddressSettings } from "./AddressSettings";
import { BirthdaySettings } from "./BirthdaySettings";
import { EmailSettings } from "./EmailSettings";
import { NameSettings } from "./NameSettings";
import { PhoneSettings } from "./PhoneSettings";
import { AppTitle } from "../../../components/AppTitle";
import { useDocumentTitle } from "../../../hooks/api/useDocumentTitle";

export function PersonalInfoPage() {
  const { t } = useTranslation();
  useDocumentTitle(`Certn ${t("Personal Info")}`);

  return (
    <>
      <AppTitle
        title={t("Personal Info")}
        subtitle={t("Please provide details and how we can contact you.")}
      />

      <ActionList ariaLabel={t("Personal Info")}>
        <NameSettings />
        <Divider />
        <BirthdaySettings />
        <Divider />
        <PhoneSettings />
        <Divider />
        <EmailSettings />
        <Divider />
        <AddressSettings />
      </ActionList>
    </>
  );
}
